var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imgs",staticClass:"imgs"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../assets/暂无数据 (2) 1.png"),"alt":""}}),_c('div',{staticStyle:{"font-size":"14px","color":"#999"}},[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }